import { useCallback, useMemo } from "react";

import { requestParamsByDashboardSortType } from "~/feature/dashboard/components/sortAndFilters/SortBy/constants";
import { DashboardSortType } from "~/feature/dashboard/components/sortAndFilters/SortBy/types";
import { useFilter } from "~/providers/FilterProvider";
import { getSortByLabel } from "~/utils/filters/getSortByLabel";

export const useSortBy = () => {
  const { sort, setSort } = useFilter();

  const selectedValue = useMemo(() => getSortByLabel(sort), [sort]);

  const onChangeSort = useCallback(
    (value: DashboardSortType) => {
      const requestParams = requestParamsByDashboardSortType[value];
      setSort({
        sortBy: requestParams.sortBy,
        sortOrder: requestParams.sortOrder,
      });
    },
    [setSort]
  );

  return { selectedValue, onChangeSort };
};
